import { render, staticRenderFns } from "./generate-card.vue?vue&type=template&id=5c53d589&"
import script from "./generate-card.vue?vue&type=script&lang=js&"
export * from "./generate-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports